import { UserRole } from "./user-role";

export const FarmTreeRoles = [
  UserRole.FarmTreeDeveloper,
  UserRole.FarmTreeMaster,
  UserRole.FarmTreeExpert,
];
